export default __webpack_public_path__ + "static/media/soesvinget-property-20.21d548a8.jpg";